module.exports = __webpack_public_path__ + "static/media/home_banner.e45dacda.png";